import React, { useState } from 'react'
import { AdonsTileProps } from '../../lib/type'
import Image from '@corratech/pylot-image'
import { AlfaRichContent as RichContent } from '@components/alfakher/pylot-rich-content'
import { Button } from '@corratech/pylot-ui'
import { QuantitySelector } from '@components/QuantitySelector/QuantitySelector'
import { useTranslation } from 'next-i18next'
import s from '@components/common/ProductTile/ProductTile.module.scss'
import ds from './AddOnsStep.module.scss'
import cn from 'classnames'
import Price from '@corratech/pylot-custom-kit-flow/src/Components/Price/Price'

export const AddOnsStep = ({
    product,
    selectedOptions,
    qty: defaultQuantity = 0,
    addOns,
    setAddOns
}: AdonsTileProps): JSX.Element => {
    const { t } = useTranslation(['common', 'plp'])

    const image = product?.thumbnail
    const [qty, setQty] = useState(defaultQuantity)
    const handleProductTileClicked = (sku?: string, qty?: number) => {
        if (!sku || !setAddOns) return
        const newAddOns = { ...addOns }
        if (!newAddOns[sku]) {
            newAddOns[sku] = { sku, qty: qty || 1 }
        } else {
            newAddOns[sku].qty = qty || 1
            if (qty === 0) {
                delete newAddOns[sku]
            }
        }

        setAddOns(newAddOns)
    }
    const getButtonLabel = () => {
        if (product?.stock_status === 'OUT_OF_STOCK') {
            return <span className="text-xs">{t('SOLD OUT')}</span>
        }
        return t('+')
    }

    return (
        <div className={cn(s['productitem-block'], ds['productitem-block'])}>
            <div className={cn('productimage-block')}>
                <div
                    className={cn(
                        s['productimg-link'],
                        ds['productimg-link'],
                        'product-card-image-swipe',
                        'slider-product-img'
                    )}
                >
                    <Image
                        src={image?.url!}
                        alt={product?.name!}
                        width={390}
                        height={390}
                        className={s['product-img']}
                    />
                </div>
            </div>
            <div
                className={cn(
                    s['plp-prod-details'],
                    'sliderproduct-detail',
                    ds['sub-title']
                )}
            >
                <p className={cn(ds['product-name'])} title={product?.name!}>
                    {product?.name}
                </p>
                <p className={cn(ds['short-description'], 'shortDesc')}>
                    <RichContent html={product?.short_description?.html!} />
                </p>
            </div>
            <div>
                <Price product={product} />
            </div>
            <div className={ds['button-container']}>
                {!addOns?.[product?.sku!] ? (
                    <Button
                        variant={
                            product?.stock_status === 'OUT_OF_STOCK'
                                ? 'flat'
                                : 'rounded'
                        }
                        className={cn(
                            selectedOptions?.includes(product?.sku!)
                                ? ds['button-selected']
                                : '',
                            product?.stock_status === 'OUT_OF_STOCK'
                                ? ds['flavour-button-OOS']
                                : '',
                            ds['flavour-button']
                        )}
                        onClick={() => {
                            setQty(1)
                            handleProductTileClicked(product?.sku!)
                        }}
                        disabled={
                            qty >= 99 ||
                            product?.stock_status === 'OUT_OF_STOCK'
                        }
                    >
                        {getButtonLabel()}
                    </Button>
                ) : (
                    <div className="pdp-qty">
                        <QuantitySelector
                            quantity={qty}
                            // @ts-ignore this is added as store folders are not tracked by ts
                            isAddingDisabled={qty >= 99}
                            // @ts-ignore this is added as store folders are not tracked by ts
                            customMin
                            min={0}
                            setQuantity={(quantity) => {
                                const quant = (quantity as number) ?? 0
                                setQty(quantity)
                                handleProductTileClicked(product?.sku!, quant)
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}
export default AddOnsStep
